var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-main',[_c('v-container',{staticClass:"side-img pa-0",attrs:{"fluid":"","fill-height":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }